import BrowsePage from 'src/dispensary/core-menu/browse';
import { getDispensaryServerSideProps } from 'src/utils/ssr/get-dispensary-server-side-props';

export const getServerSideProps = getDispensaryServerSideProps;

export default BrowsePage;
